import { LoaderHandler } from "planning-portal-library/src/lib/core/domain/models/loader-enabler";
import {
  GridHeader,
  Job,
  Plan,
  Service,
  Location, MasterPlan, JobDetails
} from "../../../core/domain";
import { PlanJobs } from "planning-portal-library/src/lib/core/domain/models/plan-details";
import { ValidateJLCsvFileResponse } from "planning-portal-library/src/lib/core/domain/requests/plans/ValidateJLCsvFileResponse";
import { MapProvider } from "planning-portal-library/src/lib/core/domain/models/map-provider.model";
import { FeatureConfiguration } from "planning-portal-library/src/lib/core/domain/models/feature-configuration";


export class SetEntityType {
  static readonly type = "[Base] Set Currently Active Entity Type";

  constructor(public payload: number | undefined) {
  }
}

export class GetGridHeaders {
  static readonly type = "[Base] Get Grid Headers";

  constructor(public payload: GridHeader[] | undefined) {
  }
}

export class UpdateGridHeaders {
  static readonly type = "[Base] Update Grid Headers";

  constructor(public payload: boolean | undefined) {
  }
}

export class SetTotalRecords {
  static readonly type = "[Base] Set Total Records For The Grid";

  constructor(public payload: number | undefined) {
  }
}

export class EnableLoading {
  static readonly type = "[Base] Enable Loading";

  constructor(public payload: LoaderHandler | undefined) {
  }
}

export class DisableLoading {
  static readonly type = "[Base] Disable Loading";

  constructor(public payload: LoaderHandler | undefined) {
  }
}

export class SetIsCreated {
  static readonly type = "[Base] Set Is Created";

  constructor(public payload: boolean | undefined) {
  }
}
export class SetIsUpdated {
  static readonly type = "[Base] Set Is Updated";

  constructor(public payload: boolean | undefined) {
  }
}

export class SetIsDeleted {
  static readonly type = "[Base] Set Is Deleted";

  constructor(public payload: boolean | undefined) {
  }
}

export class SetSelectedGroupId {
  static readonly type = "[Base] Set Selected Group Id";

  constructor(public payload: string | undefined) {
  }
}

export class SetSelectedGroupIdForImportLocation {
  static readonly type = "[Base] Set Selected Group Id";

  constructor(public payload: string | undefined) {
  }
}
export class SetBaseRoute {
  static readonly type = "[Base] Set Base Route";

  constructor(public payload: string | undefined) {
  }
}

export class SetSelectedMasterPlanForBreadcrumb {
  static readonly type = "[Base] Set Selected Master Plan For Breadcrumb";

  constructor(public payload: MasterPlan | undefined) {
  }
}

export class SetSelectedPlanForBreadcrumb {
  static readonly type = "[Base] Set Selected Plan For Breadcrumb";

  constructor(public payload: Plan | undefined) {
  }
}

export class SetMapProviders {
  static readonly type = "[Base] Set Map provider";

  constructor(public payload: MapProvider[] | undefined) {
  }
}

export class SetFeatureConfigurations {
  static readonly type = "[Base] Set tenant configurations";

  constructor(public payload: FeatureConfiguration[] | undefined) {
  }
}

export class SetValidatedJLDataForPlan {
  static readonly type = "[Base] Set Selected Plan For Breadcrumb";

  constructor(public payload: ValidateJLCsvFileResponse | undefined) {
  }
}

export class SetSelectedJobForBreadcrumb {
  static readonly type = "[Base] Set Selected Job For Breadcrumb";

  constructor(public payload: Job | undefined) {
  }
}

export class SetSelectedLocationForBreadcrumb {
  static readonly type = "[Base] Set Selected Location For Breadcrumb";

  constructor(public payload: Location | undefined) {
  }
}

export class SetSelectedServiceForBreadcrumb {
  static readonly type = "[Base] Set Selected Service For Breadcrumb";

  constructor(public payload: Service | undefined) {
  }
}
export class SetSelectedPlanDetailForBreadcrumb {
  static readonly type = "[Base] Set Selected Plan Detail For Breadcrumb";

  constructor(public payload: PlanJobs | undefined) {
  }
}

export class SetSelectedJobDetailForBreadcrumb {
  static readonly type = "[Base] Set Selected Job Detail For Breadcrumb";

  constructor(public payload: JobDetails | undefined) {
  }
}
